(() => {
  const LINK_SELECTOR = '[data-bl-cart-product-link]';
  const productVisibility = new Map();

  function sameOriginUrl(value) {
    if (!value) return null;

    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch (error) {
      return null;
    }
  }

  function isUnlistedProductDocument(html) {
    const productDocument = new DOMParser().parseFromString(html, 'text/html');

    return Array.from(productDocument.querySelectorAll('meta[name]')).some((meta) => {
      if ((meta.getAttribute('name') || '').toLowerCase() !== 'robots') return false;

      const directives = (meta.getAttribute('content') || '')
        .toLowerCase()
        .split(/[\s,]+/)
        .filter(Boolean);

      return directives.includes('noindex') && directives.includes('nofollow');
    });
  }

  function getProductVisibility(checkUrl) {
    const cacheKey = checkUrl.href;
    if (productVisibility.has(cacheKey)) return productVisibility.get(cacheKey);

    const visibilityRequest = fetch(cacheKey, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Product visibility request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => (isUnlistedProductDocument(html) ? 'unlisted' : 'listed'))
      .catch(() => {
        productVisibility.delete(cacheKey);
        return 'error';
      });

    productVisibility.set(cacheKey, visibilityRequest);
    return visibilityRequest;
  }

  function keepLinkBlocked(link, state) {
    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    link.dataset.blCartProductLinkState = state;
  }

  function enableLink(link, targetUrl) {
    if (!link.isConnected) return;

    link.setAttribute('href', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
    link.removeAttribute('aria-disabled');
    link.dataset.blCartProductLinkState = 'listed';
  }

  function checkLink(link) {
    if (link.dataset.blCartProductLinkState) return;

    const checkUrl = sameOriginUrl(link.dataset.blCartCheckUrl);
    const targetUrl = sameOriginUrl(link.dataset.blCartTargetUrl);
    if (!checkUrl || !targetUrl) {
      keepLinkBlocked(link, 'invalid');
      return;
    }

    keepLinkBlocked(link, 'checking');
    getProductVisibility(checkUrl).then((visibility) => {
      if (!link.isConnected) return;
      if (visibility === 'listed') {
        enableLink(link, targetUrl);
      } else {
        keepLinkBlocked(link, visibility);
      }
    });
  }

  function scan(root = document) {
    if (root.matches?.(LINK_SELECTOR)) checkLink(root);
    root.querySelectorAll?.(LINK_SELECTOR).forEach(checkLink);
  }

  function init() {
    scan();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
